import { Reducer } from "redux";

import { SET_USER } from "./types";
import { UserStore } from "../../../types/ReduxTypes/StoreTypes";

const initialState: UserStore = {
  currentUser: "",
};

const userReducer: Reducer<UserStore> = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return { ...state, currentUser: action.payload };
    default:
      return state;
  }
};

export default userReducer;
